exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Backtest-Tabs-___tickerDetails__spin-filler___1eCTd{width:100%;min-height:200px}\n", ""]);

// Exports
exports.locals = {
	"spin-filler": "src-components-Backtest-Tabs-___tickerDetails__spin-filler___1eCTd"
};